import { useCallback, useEffect, useMemo, useState } from 'react';
import CustomerService from 'services/customer';
import { toSearchText } from 'utils/text';

const service = new CustomerService();

const useCustomerPicker = (props = {}) => {
  const {
    onChange,
    onCustomerChange,
    placeholder = 'Chọn khách hàng',
    value,
    ...selectProps
  } = props;

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [showCustomerInfo, setShowCustomerInfo] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const list = await service.list({});
      setCustomers(list || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const options = useMemo(() => {
    return customers.map((customer) => {
      const label = `${customer.phone || ''} ${customer.full_name || ''}`.trim();

      return {
        label,
        value: customer.id,
        searchText: customer.search_text || toSearchText(label),
        customer,
      };
    });
  }, [customers]);

  const selectedCustomer = useMemo(() => {
    return customers.find((customer) => customer.id == value) || null;
  }, [customers, value]);

  const handleChange = useCallback((nextValue) => {
    onChange?.(nextValue);

    const customer = customers.find((item) => item.id == nextValue);
    if (customer) {
      onCustomerChange?.(customer);
    }
  }, [customers, onChange, onCustomerChange]);

  const handleCustomerSaved = useCallback(async (customer) => {
    await loadData();
    onChange?.(customer.id);
    onCustomerChange?.(customer);
  }, [loadData, onChange, onCustomerChange]);

  return {
    value,
    placeholder,
    selectProps,
    options,
    loading,
    selectedCustomer,
    showAddCustomer,
    setShowAddCustomer,
    showCustomerInfo,
    setShowCustomerInfo,
    onChange: handleChange,
    onCustomerSaved: handleCustomerSaved,
  };
};

export default useCustomerPicker;